@import 'styles/variables';
@import 'styles/mixins';
@import 'styles/blaze/mixins';

.wrapper {
  position: fixed;
  inset: 0;
  z-index: z-index(modal);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
  padding: 48px 16px;

  &.notCentered {
    align-items: flex-start;
    padding-top: 100px;
  }
}

.underlay {
  position: fixed;
  inset: 0;
  background-color: var(--overlay, rgba(19, 21, 26, 0.45));
  z-index: 0;
}

.modal {
  background: $white;
  border-radius: 8px;
  box-shadow: 0px 18px 64px 0px rgba(19, 21, 26, 0.22);
  position: relative;
  z-index: 1;
  outline: none;
  max-width: calc(100vw - 32px);
  width: 520px;
  margin: auto;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  border-bottom: 1px solid $gray-10;
}

.headerTitle {
  @include lg-semibold;
  color: $gray-90;
  margin: 0;
}

.closeButton {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: $gray-60;

  &:hover {
    color: $gray-90;
  }
}

.body {
  overflow: auto;
}

.footer {
  border-top: 1px solid $gray-10;
  padding: 12px 24px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

@include for-phone-only {
  .wrapper {
    padding: 0;
  }

  .modal {
    width: 100% !important;
    min-height: 100%;
    border-radius: 0;
    max-width: 100%;
  }
}
